require './tips_frontend_builder'

tipRowTemplate = require '../tip_row.html.mustache'
tipsPaginationFooter = require '../../pagination/main.html.mustache'
paginationHelper = require '../../helpers/frontend/pagination'

class Tips

  constructor: ({ @el, @csrf, @placeId, @offset, @tipCount, @maxTipLength, @minTipLength, @tipSubmitter, @tipEvents, @userTipOwnershipModel }) ->
    @$el = $ @el
    @rootUrl = '/merchant-page'
    @$tipText = @$el.find '.tip-text'
    @$tipCounter = @$el.find '.tip-counter'
    @maxTipLength = parseInt @$tipText.attr('maxlength')
    @$shareTip = @$el.find '.share-tip'
    @$loading = @$el.find '.loading'
    @$tipsTable = @$el.find '.tips-table'
    @$tipDelete = @$el.find '.tip-delete'
    @$tipsContainer = @$el.find '.tips-container'
    @$errorMessages = @$el.find '.error-messages'
    @$sharingContainer = @$el.find '.tip-sharing-container'
    @$tipsOverlay = @$el.find '#tips-load-overlay'
    @$carat = @$el.find '.carat'
    @$tipsTotal = @$el.find '.tips-total'
    @$tipsFiltering = @$el.find '.tips-filtering'
    @$sortRecent = @$el.find '.sort-recent'
    @$sortHelpful = @$el.find '.sort-helpful'

    @reportedTipIds = []
    @sortingMethod = 'date'

    @setPlaceHolder()

    @bindEventHandlers()

    @setFilteringDisplay()

  bindEventHandlers: ->
    @$sortRecent.on 'click', => @getNewTipsSortingMethod('date')
    @$sortHelpful.on 'click', => @getNewTipsSortingMethod('helpfulness')
    # these are delegated event handlers so that they also work for tips being added after page load
    @$tipsTable.on 'click', '.pagination a' , @getNewTipsPage
    @$tipsTable.on 'click', '.tip-delete', @removeTip
    @$tipsTable.on 'click', '.tip-report', @reportTip
    @$tipsTable.on 'click', '.like-tip', @likeTip
    @$tipsTable.on 'click', '.unlike-tip', @unlikeTip

    # Custom events
    @tipEvents.on 'tipSubmitSuccess', @onTipSubmitSuccess
    @userTipOwnershipModel.on('change:userHasTips', @render)

  # Render, in the meaning of, 'update the html to reflect any models we have'
  render: =>
    if @userTipOwnershipModel.get('userHasTips')
      @hideShareTipBox()
    else
      @showShareTipBox()

  setPlaceHolder: ->
    # if there are no tips and the screen is big enough, change the placeholder copy
    return if @tipCount > 0 or $(document).width() <= 350
    @$tipText.attr 'placeholder', I18n.t 'js.modules.tips.placeholder_first'

  setFilteringDisplay: ->
    return unless @$tipsFiltering.length > 0

    obj =
      placeId: @placeId
      tips_page: 1
      slug: window.location.pathname.slice(5)
      sortingMethod: 'helpfulness'

    $.ajax
      url: "#{@rootUrl}/tips/get"
      method: 'GET'
      data: obj
      contentType: 'application/json'

      success: (res) =>
        return unless res.result is 'ok'

        hasLikedTips = false
        _.each res.data.tips.tips, (tip) ->
          hasLikedTips = true if tip.likeCount > 0

        if hasLikedTips
          @$tipsFiltering.removeClass 'hide'

  getNewTipsPage: (event) =>
    event.preventDefault()
    pageNumber = $(event.currentTarget).data('page')
    slug = window.location.pathname.slice(5)
    originalQueryParams = window.location.search

    obj =
      placeId: @placeId
      tips_page: pageNumber
      slug: slug
      sortingMethod: @sortingMethod
      originalQueryParams: originalQueryParams if originalQueryParams.length > 0

    @$tipsOverlay.show()

    $('html, body').animate({
      scrollTop: @$el.offset().top - 10
    }, 100)

    @getTips obj

  getNewTipsSortingMethod: (sortingMethod) =>
    return if sortingMethod is @sortingMethod

    slug = window.location.pathname.slice(5)
    originalQueryParams = window.location.search

    obj =
      placeId: @placeId
      tips_page: 1
      slug: slug
      sortingMethod: sortingMethod
      originalQueryParams: originalQueryParams if originalQueryParams.length > 0

    @$tipsOverlay.show()

    $('html, body').animate({
      scrollTop: @$el.offset().top - 10
    }, 100)

    @getTips obj, true

  toggleSortingMethod: (sortingMethod) =>
    return if sortingMethod is false

    @sortingMethod = sortingMethod
    @$sortRecent.toggleClass 'clickable'
    @$sortHelpful.toggleClass 'clickable'

  getTips: (data, isNewSortingMethod = false) =>
    $.ajax
      url: "#{@rootUrl}/tips/get"
      method: 'GET'
      data: data
      contentType: 'application/json'

      success: (res) =>
        # TODO: error handling
        @$tipsOverlay.hide()
        return unless res.result is 'ok'

        @toggleSortingMethod(data.sortingMethod) if isNewSortingMethod
        @updateTipsRows res.data.tips
        @updatePagination res.data.tips
        @updateHeadTags res.data.tips?.paginationFooter
        paginationHelper.updateUrl res.data.tips?.paginationFooter?.currentPageNumber, 'tips_page'

        # this is needed for the "Verified Customer" tooltip
        GIG.Tooltip.reloadBindings $('.tips-module .tips-container')

      error: =>
        @$tipsOverlay.hide()
    # TODO: getMoreTips error handling

    true

  updateTipsRows: (data) ->
    data.translate = data.t = -> (text) -> I18n.translate text

    html = ''
    for singleRowData in data?.tips
      html += @generateRow singleRowData
    @$tipsTable.html html

  updatePagination: (data) ->
    data.translate = data.t = -> (text) -> I18n.translate text

    html = ''
    html = tipsPaginationFooter.render data
    @$tipsTable.append html

  updateHeadTags: (data) ->
    @updatePrevTag data?.relPrevUrl
    @updateNextTag data?.relNextUrl
    @updateCanonicalTag data?.currentPageNumber
    @updateRobots data?.currentPageNumber

  updatePrevTag: (previousUrl) ->
    return $('head link[rel=prev]').remove() unless previousUrl?

    $prev = $ 'head link[rel=prev]'
    if $prev?.length > 0
      $prev.attr 'href', previousUrl
    else
      $('head').append "<link rel='prev' href='#{previousUrl}'>"

  updateNextTag: (nextUrl) ->
    return $('head link[rel=next]').remove() unless nextUrl?

    $next = $ 'head link[rel=next]'
    if $next?.length > 0
      $('head link[rel=next]').attr 'href', nextUrl
    else
      $('head').append "<link rel='next' href='#{nextUrl}'>"

  updateCanonicalTag: (currentPageNumber) ->
    $canonical = $ 'head link[rel=canonical]'
    canonicalUrl = $canonical.attr 'href'
    queryIndex = canonicalUrl.indexOf '?'
    if queryIndex isnt -1
      canonicalUrl = canonicalUrl.substring 0, queryIndex

    tipsQueryParam = "?tips_page=#{currentPageNumber}"
    canonicalUrl = "#{canonicalUrl}#{tipsQueryParam}" if currentPageNumber isnt 1

    $canonical.attr 'href', canonicalUrl

  updateRobots: (currentPageNumber) ->
    $head = $ 'head'
    $robots = $head.find('meta[name=robots]').remove()

    $head.append("<meta name='robots' content='noindex,follow'>") if currentPageNumber > 1

  reportTip: (evt) =>
    $tipReport = $ evt.target
    $tipDeleteAndReport = $tipReport.closest '.delete-and-report'
    $tip = $tipDeleteAndReport.closest '.tip-row'
    tipId = $tip.data 'tip-id'

    cb = () =>
      $tipReport.removeClass('tip-report').removeClass('show-on-hover').text I18n.translate('js.modules.tips.reported')
      $tipDeleteAndReport.find('.tip-report-separator').removeClass('show-on-hover')
      @reportedTipIds.push tipId

    $.ajax
      url: "#{@rootUrl}/tips/#{tipId}/flag"
      method: 'POST'
      data: JSON.stringify { _csrf: @csrf }
      contentType: 'application/json'

      success: (res) =>
        cb() if not MPP.JsonResponseHandler.loginRequired(res)

  removeTip: (evt) =>
    $tip = $(evt.target)?.closest '.tip-row'
    id = $tip.data 'tip-id'

    obj =
      _csrf: @csrf
      tipId: id

    # TODO: show a loading spinner or something

    $.ajax
      url: "#{@rootUrl}/tips/delete"
      method: 'POST'
      data: JSON.stringify obj
      contentType: 'application/json'

      success: (res) =>
        return if MPP.JsonResponseHandler.loginRequired res

        # TODO: handle other errors
        return unless res.result is 'ok'

        @updateTotalTipCount @tipCount - 1

        # animate and remove row, then show share tip box
        $tip.slideUp 'fast', =>

          $tip.remove()

          # Show the share tip box if the user hasn't posted any more tips on
          # this merchant page.
          # NOTE: this might cause an issue when the user has posted more tips
          # than what is currently being shown, but that would only happen if
          # the user has submited 10+ surveys, which is an *extremely* rare
          # case.
          if @$el.find('.tip-row.user-is-owner').length == 0
            @userTipOwnershipModel.set('userHasTips', false)

        # update the footer

        # hide if there are no tips
        @$tipsContainer.addClass('hidden') if @tipCount <= 0

    false

  likeTip: (evt) =>
    $tip = $(evt.target).closest '.tip-row'
    tipId = $tip.data 'tip-id'

    $.ajax
      url: "#{@rootUrl}/tips/#{tipId}/like"
      method: 'POST'
      data: JSON.stringify { _csrf: @csrf }
      contentType: 'application/json'

      success: (res) =>
        return @updateLikeStatus($tip, res.data) if res.result is 'ok'
        MPP.JsonResponseHandler.loginRequired res

  unlikeTip: (evt) =>
    $tip = $(evt.target).closest '.tip-row'
    tipId = $tip.data 'tip-id'

    $.ajax
      url: "#{@rootUrl}/tips/#{tipId}/unlike"
      method: 'POST'
      data: JSON.stringify { _csrf: @csrf }
      contentType: 'application/json'

      success: (res) =>
        return @updateLikeStatus($tip, res.data) if res.result is 'ok'
        MPP.JsonResponseHandler.loginRequired res

  updateLikeStatus: ($tip, data) =>
    tipRow = @generateRow data
    $tip.replaceWith tipRow

  updateTotalTipCount: (newTipCount) =>
    @tipCount = newTipCount
    newText = I18n.translate('js.modules.tips.total_tips', { count: newTipCount })
    @$tipsTotal.html newText

  onTipSubmitSuccess: (res) =>
    # for initial case, show tips
    @$tipsContainer.removeClass 'hidden'

    # add the tip
    @prependNewTip res.data

    @updateTotalTipCount @tipCount + 1


  showShareTipBox: ->
    @$sharingContainer.slideDown()
    @$carat.show()

  hideShareTipBox: ->
    @$sharingContainer.slideUp()
    @$carat.hide()

  generateRow: (data) ->
    @updateTipReported data
    data.translate = data.t = -> (text) -> I18n.translate text
    tipRowTemplate.render data

  prependNewTip: (data) ->
    $row = $ @generateRow(data)
    # hide it first to get the nice slideDown animation
    $row.hide()
    @$tipsTable.prepend $row
    $row.slideDown()

  updateTipReported: (data) ->
    # Need to check both data.reported and @reportedTipIds because once a user
    # reports a tip, the "flag" user action may not appear in the API response
    # right away due to caching.
    data.reported = data.reported or _.contains(@reportedTipIds, data.id)

Groupon.Tips = Tips
